<template>
    <y-panel-grid :service="$services.Person.addressGrid" />
</template>

<script>

    import GridPageMixin from '@/mixins/GridPage';

    export default {

        name: 'ContentPostList',

        mixins: [GridPageMixin],

        /**
         * @inheritDoc
         */
        breadcrumbs() {
            return [
                this.$bc('dashboard', this.$t('breadcrumbs.dashboard')),
                this.$bc(this.$t('breadcrumbs.persons.users.list')),
                this.$bc(this.$t('breadcrumbs.persons.addresses')),
            ];
        },

    };

</script>
